import { render, staticRenderFns } from "./FormItemDesc.vue?vue&type=template&id=50a8dc88&"
import script from "./FormItemDesc.vue?vue&type=script&lang=js&"
export * from "./FormItemDesc.vue?vue&type=script&lang=js&"
import style0 from "./FormItemDesc.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports